import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {MatTableDataSource, MatPaginator, MatSort,} from '@angular/material';
import * as $ from 'jquery';

export interface Element {
  column1: string;
  column2: string;
  column3: string;
  column4: string;
  column5: string;
  column6: string;
  column7: string;
  column8: string;
  column9: string;
  column10: string;
  column11: string;
  column12: string;
}

const ELEMENT_DATA: Element[] =[
  {
    column1: "United Nations Population Division",
    column2: "https://esa.un.org/unpd/wpp/",
    column3: "None",
    column4: "Population",
    column5: "Not an SDG indicator",
    column6: "6.0.1.1",
    column7: "Number of people ('000,000)",
    column8: "",
    column9: "United Nations Population Division",
    column10: "http://esa.un.org/unpd/wpp/DataQuery/",
    column11: "",
    column12: ""
  },
  {
    column1: "Draft tool for calculating safely managed drinking water and sanitation services from the WHO/UNICEF Joint Monitoring Programme for Water Supply and Sanitation (JMP) - for the tool, scroll down to 'Supplementary materials on safely managed drinking water and sanitation'",
    column2: "http://www.wssinfo.org/sdg-baselines/",
    column3: "6.1.1",
    column4: "Percentage of population using safely managed drinking water services",
    column5: "Tier 1",
    column6: "6.1.1.1",
    column7: "Percentage population using safely managed drinking water services",
    column8: "https://unstats.un.org/sdgs/metadata/",
    column9: "JMP is initiating a new data drive. 2 page data request forms have been developed that specify the information required by the JMP in order to calculate baseline estimates for each of the SDG indicators: see",
    column10: "",
    column11: "",
    column12: "http://www.wssinfo.org/fileadmin/user_upload/resources/Indicator-6-1-1-Safely-Managed-Drinking-Water.pdf"
  },
  {
    column1: "WHO/UNICEF Joint Monitoring Programme for Water Supply and Sanitation (JMP)",
    column2: "http://www.wssinfo.org/data-estimates/",
    column3: "6.1.1",
    column4: "Proportion of population using an improved drinking water source",
    column5: "MDG Indicator 7.8",
    column6: "6.1.1.2",
    column7: "Proportion of population using an improved drinking water source",
    column8: "",
    column9: "WHO/UNICEF Joint Monitoring Programme for Water Supply and Sanitation (JMP) MDG Data",
    column10: "http://www.wssinfo.org/documents/?tx_displaycontroller[type]=country_files",
    column11: "http://www.wssinfo.org/data-estimates/tables/",
    column12: ""
  },
  {
    column1: "Draft tool for calculating safely managed drinking water and sanitation services from the WHO/UNICEF Joint Monitoring Programme for Water Supply and Sanitation (JMP) - for the tool, scroll down to 'Supplementary materials on safely managed drinking water and sanitation'",
    column2: "http://www.wssinfo.org/sdg-baselines/",
    column3: "6.2.1",
    column4: "Percentage of population using safely managed sanitation services, including a hand-washing facility with soap and water",
    column5: "Tier 1",
    column6: "6.2.1.1",
    column7: "Percentage of population using safely managed sanitation and hygiene services",
    column8: "https://unstats.un.org/sdgs/metadata/",
    column9: "JMP is initiating a new data drive. 2 page data request forms have been developed that specify the information required by the JMP in order to calculate baseline estimates for each of the SDG indicators: see",
    column10: "",
    column11: "",
    column12: "http://www.wssinfo.org/fileadmin/user_upload/resources/SDG-6-2-1-Safely-Managed-Sanitation-Services-and-Hygiene.pdf"
  },
  {
    column1: "WHO/UNICEF Joint Monitoring Programme for Water Supply and Sanitation (JMP)",
    column2: "http://www.wssinfo.org/data-estimates/",
    column3: "6.2.1",
    column4: "Proportion of population using an improved sanitation facility",
    column5: "MDG Indicator 7.9",
    column6: "6.2.1.2",
    column7: "Proportion of population using an improved sanitation facility",
    column8: "",
    column9: "WHO/UNICEF Joint Monitoring Programme for Water Supply and Sanitation (JMP) MDG Data",
    column10: "http://www.wssinfo.org/documents/?tx_displaycontroller[type]=country_files",
    column11: "http://www.wssinfo.org/data-estimates/tables/",
    column12: ""
  },
  {
    column1: "Draft tool for calculating safely managed drinking water and sanitation services from the WHO/UNICEF Joint Monitoring Programme for Water Supply and Sanitation (JMP) - for the tool, scroll down to 'Supplementary materials on safely managed drinking water and sanitation'",
    column2: "http://www.unwater.org/publications/step-step-methodology-monitoring-wastewater-treatment-6-3-1/",
    column3: "6.3.1",
    column4: "Proportion of wastewater safely treated",
    column5: "Tier 3",
    column6: "6.3.1.1",
    column7: "Percentage of (hazardous) wastewater from economic activities that is safely treated",
    column8: "http://www.sdg6monitoring.org/news/indicators/631",
    column9: "Some Water Quality Index information at country level is available from UNEP's GEMStat. Data are also available from the OECD.",
    column10: "",
    column11: "",
    column12: ""
  },
  {
    column1: "UN-Water suggest a combination of international data sources that do not yet report statistics at national level. Data required will overlap with that of 6.2.1. The aim in 2017 is to build on JMP, AQUASTAT, IBNET, the UNSD/UNEP Water Questionnaire for non-OECD countries, the OECD/Eurostat Questionnaire for OECD Countries as well as satellite and other remote imagery.",
    column2: "http://www.unwater.org/publications/step-step-methodology-monitoring-wastewater-treatment-6-3-1/",
    column3: "6.3.1",
    column4: "Proportion of wastewater safely treated",
    column5: "Tier 3",
    column6: "6.3.1.2",
    column7: "Percentage of wastewater safely treated that originates from household sources",
    column8: "http://www.sdg6monitoring.org/news/indicators/631",
    column9: "Some Water Quality Index information at country level is available from UNEP's GEMStat. Data are also available from the OECD.",
    column10: "http://www.waterandchange.org/en/#gemstat",
    column11: "",
    column12: "Household and service provider survey templates can be found in the methodology for 6.3.1 at: http://www.unwater.org/publications/publications-detail/en/c/422705/ and through JMP at: Household and service provider survey"
  },
  {
    column1: "As monitoring capacities and coverage vary between countries, refer to UN-Water metadata to determine which parameters you would like to use to measure 6.3.2",
    column2: "http://www.unwater.org/publications/step-step-methodology-monitoring-water-quality-6-3-2/",
    column3: "6.3.2",
    column4: "Proportion of bodies of water with good ambient water quality",
    column5: "Tier 3",
    column6: "6.3.2.1",
    column7: "Percentage of water bodies with good quality",
    column8: "http://www.sdg6monitoring.org/news/indicators/632",
    column9: "Data should be collected at national level, with basic laboratory services needed to carry out testing.",
    column10: "http://www.waterandchange.org/en/#gemstat",
    column11: "",
    column12: "Water samples should be taken regularly  from representative monitoring locations for selected waterbodies (i.e., rivers, lakes, groundwaters). These samples should be analysed for the core parameters [i.e.,  Dissolved Oxygen (DO), Electrical Conductivity (EC), pH, Orthophosphate (OP), and Total Oxidised Nitrogen (TON)] and the results of the analyses recorded for each monitoring location. Collected data should be comparade against thresholds set for each parameter and a score of 1 or 0 assigned to each station in each waterbody. These values are further converted into % compliance per station and per waterbody, where values over 80% are \"good\" and anything below is \"not good\". The number of \"good\" and \"not good\" are requested for this PSS.  \nData collection templates can be found directly at: https://www.dropbox.com/sh/5gptcb882admnb5/AABPK3kNrRJ_slPh0s99PIXea?dl=0\nor: http://www.sdg6monitoring.org/news/indicators/632"
  },
  {
    column1: "Data should be obtained from national statistics with the help of additional international sources such as FAOSTAT where necessary. Gross value added in national currency will be obtained from national statisctics and converted to USD, and deflated to the baseline year 2015.",
    column2: "http://www.unwater.org/publications/step-step-methodology-monitoring-water-use-efficiency-6-4-1/",
    column3: "6.4.1",
    column4: "Percentage change in water use efficiency over time",
    column5: "Tier 3",
    column6: "6.4.1.1",
    column7: "Change in water use efficiency of industry (iincluding power production)",
    column8: "http://www.fao.org/nr/water/aquastat/main/index.stm",
    column9: "GVAi - \"Gross value added by industry\" is available from national statistics; World Bank Databank; UNSD; OECD. Vi - \"Volume of water withdrawn by the industries\" is available at the national level and from the FAOSTAT database.",
    column10: "http://www.fao.org/faostat/en/#data/EL",
    column11: "World Bank Databank: http://databank.worldbank.org/data/home.aspx\nUNSD: http://unstats.un.org/unsd/snaama/selbasicFast.asp\nOECD – national accounts data files\nhttp://www.oecd-ilibrary.org/economics/data/oecd-national-accounts-statistics_nadata-en",
    column12: "Iwe = GVAi/Vi"
  },
  {
    column1: "Data should be obtained from national statistics with the help of additional international sources such as FAOSTAT where necessary. Gross value added in national currency will be obtained from national statisctics and converted to USD, and deflated to the baseline year 2015.",
    column2: "http://www.unwater.org/publications/step-step-methodology-monitoring-water-use-efficiency-6-4-1/",
    column3: "6.4.1",
    column4: "Percentage change in water use efficiency over time",
    column5: "Tier 3",
    column6: "6.4.1.2",
    column7: "Change in water use efficiency of irrigated agriculture",
    column8: "http://www.fao.org/nr/water/aquastat/main/index.stm",
    column9: "GVAa - \"Gross value added by agriculture\" is available from national statistics, World Bank Databank; UNSD; OECD. Cr - \"Proportion of agricultural GVA produced by rainfed agriculture\" see methodology. Va - \"Volume of water withdrawn by the agricultural sector\" is available at national level and from the FAO Aquastat database.",
    column10: "http://www.fao.org/faostat/en/#data/EL",
    column11: "World Bank Databank: http://databank.worldbank.org/data/home.aspx\nUNSD: http://unstats.un.org/unsd/snaama/selbasicFast.asp\nOECD – national accounts data files\nhttp://www.oecd-ilibrary.org/economics/data/oecd-national-accounts-statistics_nadata-en",
    column12: "Awe = GVAa x (1-Cr)/Va. Cr can be calculated from the proportion of irrigated land on the total arable land, as follows: Cr = 1/1 + (Ai/(1 − Ai) * 0.375). Where Ai = proportion of irrigated land on the total arable land, in decimals, and 0.375 = generic default ratio between rainfed and irrigated yields. Va: The volume of water withdrawn by the agricultural sectors is collected at country level through national records and reported in questionnaires, in units of m3/year (see example in AQUASTAT http://www.fao.org/nr/water/aquastat/sets/aq-5yr-quest_eng.xls)"
  },
  {
    column1: "Data should be obtained from national statistics with the help of additional international sources such as FAOSTAT where necessary. Gross value added in national currency will be obtained from national statisctics and converted to USD, and deflated to the baseline year 2015.",
    column2: "http://www.unwater.org/publications/step-step-methodology-monitoring-water-use-efficiency-6-4-1/",
    column3: "6.4.1",
    column4: "Percentage change in water use efficiency over time",
    column5: "Tier 3",
    column6: "6.4.1.3",
    column7: "Change in water use efficiency of water supply services",
    column8: "http://www.fao.org/nr/water/aquastat/main/index.stm",
    column9: "GVAs - \"Gross value added by services\" is available from national statistics, World Bank Databank; UNSD; OECD. Vs - \"Volume of water withdrawn by the service sector\" is available at national level and from the FAO Aquastat database.",
    column10: "http://www.fao.org/faostat/en/#data/EL",
    column11: "World Bank Databank: http://databank.worldbank.org/data/home.aspx\nUNSD: http://unstats.un.org/unsd/snaama/selbasicFast.asp\nOECD – national accounts data files\nhttp://www.oecd-ilibrary.org/economics/data/oecd-national-accounts-statistics_nadata-en",
    column12: "Swe = GVAS /VS"
  },
  {
    column1: "FAO Aquastat through GEMI, on behalf of UN-Water",
    column2: "http://www.unwater.org/publications/step-step-methodology-monitoring-water-stress-6-4-2/",
    column3: "6.4.2",
    column4: "Level of water stress: freshwater withdrawal in percentage of available freshwater resources",
    column5: "Tier 1",
    column6: "6.4.2.1",
    column7: "Reduction in percentage of freshwater withdrawal compared to available freshwater resources",
    column8: "http://www.fao.org/nr/water/aquastat/main/index.stm",
    column9: "TRWR - \"Total renewable water resources\" and TWW - \"Total water withdrawn\" are available at national level from the FAO Aquastat database",
    column10: "http://www.fao.org/nr/water/aquastat/data/query/index.html?lang=en",
    column11: "http://www.sdg6monitoring.org/news/indicators/642",
    column12: "Stress % = TWW / TRWR - Env. * 100  Although TWW and TRWR are directly available from FAO Aquastat, the metadata guidelines suggest TWW = the sum of total water withdrawal by sector (agriculture, municipal, industry) minus direct use of wastewater, direct use of agricultural drainage water and use of desalinated water. however, the direct use of wastewater, direct use of agricultural drainage water and use of desalinated water is not available in Aquastat. Measures of Env. \"Environmental water requirements\" are currently only available at basin level for major basins in the world, not country level - see Smakhtin, V., Revenga, C., & Döll, P. (2004). A pilot global assessment of environmental water requirements and scarcity, Water International, 29(3), 307-317."
  },
  {
    column1: "IWRM surveys are available through the IWRM data portal. Currently, some data are available from  two global IWRM surveys (years 2007 and 2011) undertaken by UNEP.",
    column2: "http://iwrmdataportal.unepdhi.org/iwrmmonitoring.html",
    column3: "6.5.1",
    column4: "Degree of integrated water resource management (IWRM) implementation",
    column5: "Tier 1",
    column6: "6.5.1.1",
    column7: "Improvement in policy, legal and strategic planning tools (i.e. enabling environment) score",
    column8: "http://www.unwater.org/publications/step-step-methodology-monitoring-integrated-water-resources-management-6-5-1/",
    column9: "",
    column10: "http://iwrmdataportal.unepdhi.org/dataoverview.html",
    column11: "",
    column12: "The indicator is determined from the results of the IWRM questionnaire, which is divided into 4 sections. The section for this sub-indicator consists of 7 questions. Each question has a response value of between 0 and 100, in increments of 10. Question scores are averaged to form a section score. The section scores are then averaged to create an indicator score on a scale of 0-100, which represents the degree of IWRM integration. If a response of ‘not applicable (n/a)’ is given, this is not included in the calculation. The questionnaire can be found at: http://iwrmdataportal.unepdhi.org/iwrmmonitoring.html"
  },
  {
    column1: "IWRM surveys are available through the IWRM data portal. Currently, some data are available from  two global IWRM surveys (years 2007 and 2011) undertaken by UNEP.",
    column2: "http://iwrmdataportal.unepdhi.org/iwrmmonitoring.html",
    column3: "6.5.1",
    column4: "Degree of integrated water resource management (IWRM) implementation",
    column5: "Tier 1",
    column6: "6.5.1.2",
    column7: "Improvement in institutions and participation score",
    column8: "http://www.unwater.org/publications/step-step-methodology-monitoring-integrated-water-resources-management-6-5-1/",
    column9: "",
    column10: "http://iwrmdataportal.unepdhi.org/dataoverview.html",
    column11: "",
    column12: "The indicator is determined from the results of the IWRM questionnaire, which is divided into 4 sections. The section for this sub-indicator consists of 12 questions. Each question has a response value of between 0 and 100, in increments of 10. Question scores are averaged to form a section score. The section scores are then averaged to create an indicator score on a scale of 0-100, which represents the degree of IWRM integration. If a response of ‘not applicable (n/a)’ is given, this is not included in the calculation. The questionnaire can be found at: http://iwrmdataportal.unepdhi.org/iwrmmonitoring.html"
  },
  {
    column1: "IWRM surveys are availble through the IWRM data portal. Currently, some data are available from  two global IWRM surveys (years 2007 and 2011) undertaken by UNEP.",
    column2: "http://iwrmdataportal.unepdhi.org/iwrmmonitoring.html",
    column3: "6.5.1",
    column4: "Degree of integrated water resource management (IWRM) implementation",
    column5: "Tier 1",
    column6: "6.5.1.3",
    column7: "Improvement in management instruments score",
    column8: "http://www.unwater.org/publications/step-step-methodology-monitoring-integrated-water-resources-management-6-5-1/",
    column9: "",
    column10: "http://iwrmdataportal.unepdhi.org/dataoverview.html",
    column11: "",
    column12: "The indicator is determined from the results of the IWRM questionnaire, which is divided into 4 sections. The section for this sub-indicator consists of 9 questions. Each question has a response value of between 0 and 100, in increments of 10. Question scores are averaged to form a section score. The section scores are then averaged to create an indicator score on a scale of 0-100, which represents the degree of IWRM integration. If a response of ‘not applicable (n/a)’ is given, this is not included in the calculation. The questionnaire can be found at: http://iwrmdataportal.unepdhi.org/iwrmmonitoring.html"
  },
  {
    column1: "IWRM surveys are availble through the IWRM data portal. Currently, some data are available from  two global IWRM surveys (years 2007 and 2011) undertaken by UNEP.",
    column2: "http://iwrmdataportal.unepdhi.org/iwrmmonitoring.html",
    column3: "6.5.1",
    column4: "Degree of integrated water resource management (IWRM) implementation",
    column5: "Tier 1",
    column6: "6.5.1.4",
    column7: "Improvement in financing score",
    column8: "http://www.unwater.org/publications/step-step-methodology-monitoring-integrated-water-resources-management-6-5-1/",
    column9: "",
    column10: "http://iwrmdataportal.unepdhi.org/dataoverview.html",
    column11: "",
    column12: "The indicator is determined from the results of the IWRM questionnaire, which is divided into 4 sections. The section for this sub-indicator consists of 5 questions. Each question has a response value of between 0 and 100, in increments of 10. Question scores are averaged to form a section score. The section scores are then averaged to create an indicator score on a scale of 0-100, which represents the degree of IWRM integration. If a response of ‘not applicable (n/a)’ is given, this is not included in the calculation. The questionnaire can be found at: http://iwrmdataportal.unepdhi.org/iwrmmonitoring.html"
  },
  {
    column1: "UN-Water suggest that data will most reliably be collected at national level.",
    column2: "http://www.unwater.org/publications/step-step-methodology-monitoring-transboundary-cooperation-6-5-2/",
    column3: "6.5.2",
    column4: "Proportion of transboundary basin area with an operational arrangement for water cooperation",
    column5: "Tier 3",
    column6: "6.5.2.1",
    column7: "Percentage of total surface area of transboundary basins that have an operational arrangement for water cooperation",
    column8: "https://unstats.un.org/sdgs/metadata/",
    column9: "",
    column10: "",
    column11: "",
    column12: ""
  },
  {
    column1: "The primary data source will be the National reports of the Ramsar Convention.",
    column2: "http://www.unwater.org/publications/step-step-methodology-monitoring-ecosystems-6-6-1/",
    column3: "6.6.1",
    column4: "Percentage of change in the extent of water-related ecosystems over time",
    column5: "Tier 3",
    column6: "6.6.1.1",
    column7: "Change in the spatial extent of surface water-related ecosystems",
    column8: "http://www.sdg6monitoring.org/news/indicators/661",
    column9: "National reports to the Ramsar Convention. Other  possible data sources include EO (Earth Observation) methods – images and data describing the location and spatial extent of most water-related ecosystems are freely available at down to 10m resolution, which needs to be interpreted in order to determine ecosystem extent.",
    column10: "https://rsis.ramsar.org/ris-search/",
    column11: "",
    column12: "C%i = (CPD/R)*100\nand CPD = |R–PD|\n\nWhere: \nC % = Percentage change of the Present Day condition score from the Reference condition for sub - indicator i. \nCPD = Change of Present Day condition score from the Reference condition \nR = Sub - indicator score set for the Reference Condition (section 3 .1) \nPD = Sub - indicator score obtained for the Present Day Condition \n\nSee methodology for indicator 6.6.1, for details on calculations and measurement at: http://www.unwater.org/publications/step-step-methodology-monitoring-ecosystems-6-6-1/\nData collection and submission forms can be found at: https://www.dropbox.com/sh/5gptcb882admnb5/AABPK3kNrRJ_slPh0s99PIXea?dl=0"
  },
  {
    column1: "UN-Water suggests a combination of data sources. The flow of water in a river is best represented by collection of data from a flow measurement station, with long term (>50 years) being ideal. As an alternative, the flow in a river may be modelled from one of the many available models that use climate and land-use data amongst others to estimate both the natural state and present day condition.",
    column2: "http://www.unwater.org/publications/step-step-methodology-monitoring-ecosystems-6-6-1/",
    column3: "6.6.1",
    column4: "Percentage of change in the extent of water-related ecosystems over time",
    column5: "Tier 3",
    column6: "6.6.1.2",
    column7: "Change in quantity of water stored in rivers and open water bodies",
    column8: "http://www.sdg6monitoring.org/news/indicators/661",
    column9: "There are also global assessments and repositories of river flow data. For example the Global Runoff Database at GRDC, which is a unique collection of river discharge data collected at daily or monthly intervals from more than 9,000 stations in 160 countries. HydroWeb (LEGOS) is a database of water levels using altimetry (EO method), and changes to groundwater table/shallow aquifers are done by the Grace mission (NASA). Global Groundwater Information System (GGIS) of IGRAC, which is part of UNESCO.",
    column10: "http://www.fao.org/forest-resources-assessment/explore-data/flude/en/",
    column11: "http://www.fao.org/forestry/mangrove/statistics/en/",
    column12: "Stream-flow: See methodology\nLake and reservoir volume: V = 0.5H*(A1 + A2) Where V = volume of water; H = difference in depth between two successive depth contours; A1 = area of the lake within the outer depth contour being considered; A2 = area of the lake within the inner contour line under consideration.\nGroundwater volume: ((∆Vaq1 +  ∆Vaq2 + ... + ∆Vaqn)/(Vrefaq1+ Vrefaq2 + ... + Vrefaqn)) * 100; Where: ∆V = A * ∆h * S; Vref = A * b * S; Where: A = aquifer areal extent, b = average saturated aquifer thickness, S = Storativity / storage coefficient (see below), and Δh = average change in hydraulic head (average change in groundwater level measured in monitoring wells relative to the natural reference). \nSee methodology for indicator 6.6.1, for details on calculations and measurement at: http://www.unwater.org/publications/step-step-methodology-monitoring-ecosystems-6-6-1/\nData collection and submission forms can be found at: https://www.dropbox.com/sh/5gptcb882admnb5/AABPK3kNrRJ_slPh0s99PIXea?dl=0"
  },
  {
    column1: "Since this sub-indicator is based on indicator 6.3.2, so deos the source. As monitoring capacities and coverage vary between countries, refer to UN-Water metadata to determine which parameters to use to measure 6.3.2.",
    column2: "http://www.unwater.org/publications/step-step-methodology-monitoring-ecosystems-6-6-1/",
    column3: "6.6.1",
    column4: "Percentage of change in the extent of water-related ecosystems over time",
    column5: "Tier 3",
    column6: "6.6.1.3",
    column7: "Percentage change in the quality of water in water-related ecosystems",
    column8: "http://www.sdg6monitoring.org/news/indicators/661",
    column9: "See 6.3.2",
    column10: "None available",
    column11: "",
    column12: "The procedure for monitoring of water quality is documented in the SDG Indicator 6.3.2. However indicator 6.6.1 requires the measure to be represented as percentage change over time. Accordingly, the data from indicator 6.3.2 needs to be converted in the following way:\nAn assumption is made for indicator 6.6.1 that if 100% of the water bodies are in “good” condition that would approximate a natural reference condition. Thus a 6.3.2 score of 65% (i.e. proportion of bodies of water with good ambient water quality), would equal a 6.6.1 score of 35% (i.e. a percentage change from the natural/good condition). \nSee methodology for indicator 6.6.1, for details on calculations and measurement at: http://www.unwater.org/publications/step-step-methodology-monitoring-ecosystems-6-6-1/\nData collection and submission forms can be found at: https://www.dropbox.com/sh/5gptcb882admnb5/AABPK3kNrRJ_slPh0s99PIXea?dl=0"
  },
  {
    column1: "Most of the data on ecosystem state or health will be collected and stored at a local or national level. UN-Water suggests a combination of data sources.",
    column2: "http://www.unwater.org/publications/step-step-methodology-monitoring-ecosystems-6-6-1/",
    column3: "6.6.1",
    column4: "Percentage of change in the extent of water-related ecosystems over time",
    column5: "Tier 3",
    column6: "6.6.1.4",
    column7: "(Optional - only for national reporting)  Percentage change in health or state of water-related ecosystems [relative to natural state (100%)]",
    column8: "http://www.sdg6monitoring.org/news/indicators/661",
    column9: "For national reporting only and context dependent, therefore international sources do not exist",
    column10: "None available",
    column11: "",
    column12: "Prioritise which ecosystems are to be assessed (i.e. Rivers and estuaries; open water (lakes); Vegetated wetlands – suggest limit to priority wetlands only).  methods used for monitoring health of water-related ecosystems  are different for each type of ecosystem. See methodology for examples (Habitat Integrity, fish condition indices, Benthic macroinvertebrate indices, Diatoms, Vegetation, Wetland health indices, lake health indices and Groundwater ecosystems). In order to change this to a situation suitable for SDG reporting, it is required that each method used be adapted so that the final score produced is presented as a percentage relative to natural where 100% equals the natural condition and 0% equals a situation where the services provided by the ecosystem are negligible. \nSee methodology for indicator 6.6.1, for details on calculations and measurement at: http://www.unwater.org/publications/step-step-methodology-monitoring-ecosystems-6-6-1/\nData collection and submission forms can be found at: https://www.dropbox.com/sh/5gptcb882admnb5/AABPK3kNrRJ_slPh0s99PIXea?dl=0"
  },
  {
    column1: "SIASAR (Rural Water and Sanitation Information System)-system classification - WSP",
    column2: "http://documents.worldbank.org/curated/en/709121468339566486/The-SIASAR-initiative-an-information-system-for-more-sustainable-rural-water-and-sanitation-services",
    column3: "",
    column4: "",
    column5: "",
    column6: "",
    column7: "",
    column8: "",
    column9: "None found",
    column10: "None",
    column11: "",
    column12: ""
  }
 ];
@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css']
})
export class StatusComponent implements OnInit {

//@ViewChild(MatPaginator) paginator: MatPaginator;
@ViewChild(MatSort) sort: MatSort;

  displayedColumns = ['column1', 'column2', 'column3', 'column4', 'column5', 'column6', 'column7', 'column8', 'column12'];
//  displayedColumns = ['column1', 'column2', 'column3', 'column4', 'column5', 'column6', 'column7', 'column8', 'column9', 'column10', 'column11', 'column12'];
  dataSource: MatTableDataSource<Element>;

  constructor(private router: Router) {
    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
   }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".status-click").addClass("header_active")
  }
  ngAfterViewInit() {
    //this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  quesBtnClick(){
    this.router.navigateByUrl('/sdg/status-quest')
  }
  dataBtnClick(){
    this.router.navigateByUrl('/sdg/status-data')
  }
  reportBtnClick(){
    this.router.navigateByUrl('/sdg/status-report')
  }
  homeBtnClick(){
      this.router.navigateByUrl('/sdg/sdg-home')
  }
}



// WEBPACK FOOTER //
// ./src/app/sdg/status/status.component.ts